/* FB REVEAL — elementer med .fb-reveal fader ind naar de rammer viewporten.
   Idempotent: kan indlaeses af flere sektioner uden at dublere observers. */
(function () {
  'use strict';
  if (window.__fbRevealInit) return;
  window.__fbRevealInit = true;

  var reduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll() {
    document.querySelectorAll('.fb-reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  if (reduced || !('IntersectionObserver' in window)) {
    showAll();
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        // Lille trappe-forsinkelse indenfor samme raekke
        var siblings = Array.prototype.slice.call(
          entry.target.parentElement ? entry.target.parentElement.children : []
        );
        var idx = siblings.indexOf(entry.target);
        entry.target.style.transitionDelay = Math.min(idx % 4, 3) * 70 + 'ms';
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
  );

  function observe(scope) {
    (scope || document).querySelectorAll('.fb-reveal:not(.is-in)').forEach(function (el) {
      io.observe(el);
    });
  }

  observe();

  // Theme editor: nye sektioner skal ogsaa fanges
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
  });
})();
